import * as EventListener from "../../common/helpers/event-listener";
import csrfToken from "../../common/helpers/csrf-token";
import flatpickr from "flatpickr";
import Validator from "../../common/validator/validator";
import Bowser from "bowser";

const initCalendar = () => {
    const productCalendarElement = document.getElementById("productCalendar");

    if (!productCalendarElement) {
        return;
    }

    const calendarDataInput = document.getElementById("calendarData");
    const monthDataInput = document.getElementById("monthData");
    const dayOfWeekDataInput = document.getElementById("dayOfWeekData");

    const calendarData = JSON.parse(calendarDataInput.value);
    const monthData = JSON.parse(monthDataInput.value);
    const dayOfWeekData = JSON.parse(dayOfWeekDataInput.value);

    const disabledDates = [];
    let defaultDate = null;

    Object.keys(calendarData).forEach((date) => {
        const itemCalendarData = calendarData[date];

        if (itemCalendarData.disabled) {
            disabledDates.push(date);
        } else {
            if (!defaultDate) {
                defaultDate = date;
            }
        }
    });

    flatpickr("#deliveryCalendar", {
        inline: true,
        prevArrow: "<",
        nextArrow: ">",
        minDate: "today",
        defaultDate: defaultDate,
        maxDate: new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 2,
            0,
        ),
        disable: disabledDates,
        locale: {
            weekdays: {
                shorthand: dayOfWeekData,
                longhand: dayOfWeekData,
            },
            months: {
                shorthand: monthData,
                longhand: monthData,
            },
        },
        onDayCreate: (dateObject, dateString, fp, dayElement) => {
            const dateObj = dayElement.dateObj;

            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, "0");
            const day = String(dateObj.getDate()).padStart(2, "0");

            const formattedDate = `${year}-${month}-${day}`;

            dayElement.setAttribute("data-date", formattedDate);
        },
        onChange: (selectedDates, dateStr) => {
            changeOfferOrderDate(dateStr);
        },
    });
};

const disableProductPageFields = (disabled) => {
    const searchInput = document.getElementById("productLocalitySearch");

    if (searchInput) {
        searchInput.disabled = disabled;
    }

    const addCartPositionToCartButton = document.getElementById(
        "addCartPositionToCartButton",
    );

    if (addCartPositionToCartButton) {
        addCartPositionToCartButton.disabled = disabled;
    }

    const offerOrderDateTimeInput = document.getElementById(
        "offerOrderDateTimeInput",
    );

    if (offerOrderDateTimeInput) {
        offerOrderDateTimeInput.disabled = disabled;
    }

    document
        .querySelectorAll(".change-shipping-type-radio")
        .forEach((element) => {
            element.disabled = disabled;
        });

    document.querySelectorAll(".add-one-offer-button").forEach((element) => {
        element.disabled = disabled;
    });

    document.querySelectorAll(".remove-one-offer-button").forEach((element) => {
        element.disabled = disabled;
    });
};

const focusOnActiveCartPosition = () => {
    const element = document.querySelector(".bouquet-item.selected");
    const container = document.querySelector(".order-bouquets-block");

    if (!element || !container) {
        return;
    }

    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    container.scrollTo({
        left:
            elementRect.left -
            containerRect.left +
            container.scrollLeft -
            (container.clientWidth / 2 - elementRect.width / 2),
        behavior: "smooth",
    });
};

const search = () => {
    let debounceTimer;

    EventListener.input("productLocalitySearch", (input) => {
        clearTimeout(debounceTimer);

        const search = input.value.trim().toLowerCase();

        document.querySelector(
            ".product-locality-search-result-wrapper",
        ).textContent = null;

        if (search.length < 2) {
            return;
        }

        debounceTimer = setTimeout(() => {
            oc.ajax("Settings::onAjax", {
                data: {
                    _token: csrfToken,
                    locality_search: search,
                },
                update: {
                    "catalog/product-page/locality-search/search-results":
                        ".product-locality-search-result-wrapper",
                },
            });
        }, 300);
    });
};

const changeLocality = () => {
    EventListener.click("change-product-locality-button", (button) => {
        disableProductPageFields(true);

        const searchInput = document.getElementById("productLocalitySearch");

        document.querySelector(
            ".product-locality-search-result-wrapper",
        ).textContent = null;

        const offerId = document.getElementById("offerId").value;
        const localityId = button.getAttribute("data-locality-id");
        const localityName = button.getAttribute("data-locality-name");

        searchInput.value = localityName.trim();

        oc.ajax("Cart::onChangeLocality", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                locality_id: localityId,
                offer_id: offerId,
            },
            update: {
                "catalog/product-page/cart-form/cart-form":
                    ".cart-form-wrapper",
            },
        });
    });
};

const changeShippingType = () => {
    EventListener.change("change-shipping-type-radio", (radio) => {
        disableProductPageFields(true);

        const offerId = document.getElementById("offerId").value;

        oc.ajax("Settings::onAjax", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                shipping_type: radio.value,
                offer_id: offerId,
            },
            update: {
                "catalog/product-page/cart-form/cart-form":
                    ".cart-form-wrapper",
            },
        });
    });
};

const changeOfferOrderDateByTab = () => {
    EventListener.change("offer-order-date-radio", (radio) => {
        let date = radio.value;

        if (!date) {
            initCalendar();

            date = document
                .querySelectorAll(".flatpickr-day.selected")[0]
                .getAttribute("data-date");
        }

        changeOfferOrderDate(date, radio);
    });
};

const changeOfferOrderDate = (date, tabRadio = null) => {
    document.querySelectorAll(".offer-order-date-radio").forEach((element) => {
        element.disabled = true;
    });

    document.querySelectorAll(".offer-order-time-radio").forEach((element) => {
        element.disabled = true;
    });

    const partnerId = document.getElementById("partnerId").value;
    const localityId = document.getElementById("localityId").value;
    const shippingType = document.querySelector(
        ".change-shipping-type-radio:checked",
    ).value;
    const offerId = document.getElementById("offerId").value;

    oc.ajax("Settings::onAjax", {
        loading: "#loader-line",
        data: {
            _token: csrfToken,
            partner_id: partnerId,
            locality_id: localityId,
            shipping_type: shippingType,
            offer_id: offerId,
            date: date,
        },
        update: {
            "catalog/product-page/cart-form/time-slots": ".time-slots-wrapper",
        },
        complete: () => {
            const calendarBlock = document.querySelector(".calendar-block");

            if (tabRadio) {
                if (tabRadio.id === "date-calendar") {
                    calendarBlock.classList.remove("hidden");
                } else {
                    calendarBlock.classList.add("hidden");
                }
            }

            document
                .querySelectorAll(".offer-order-date-radio")
                .forEach((element) => {
                    element.disabled = false;
                });

            document
                .querySelectorAll(".offer-order-time-radio")
                .forEach((element) => {
                    element.disabled = false;
                });
        },
    });
};

const changeOfferOrderTime = () => {
    EventListener.change("offer-order-time-radio", (radio) => {
        disableProductPageFields(true);

        const tabRadio = document.querySelector(
            ".offer-order-date-radio:checked",
        );

        let date = null;

        if (tabRadio.getAttribute("data-type") === "calendar") {
            date = document
                .querySelector(".flatpickr-day.selected")
                .getAttribute("data-date");
        } else {
            date = tabRadio.value;
        }

        if (!date) {
            throw new Error("Date not found");
        }

        const time = radio.value;
        const timeText = document
            .getElementById(`time_slot_text_${time}`)
            .textContent.trim();
        const dateTimeText = `${date} ${timeText}`;
        const partnerId = document.getElementById("partnerId").value;
        const localityId = document.getElementById("localityId").value;
        const shippingTypePriceValue = document
            .querySelector(".change-shipping-type-radio:checked")
            .getAttribute("data-price-value");
        const isExpressDelivery = radio.getAttribute("data-express-delivery");

        oc.ajax("Settings::onAjax", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                delivery_date: date,
                partner_id: partnerId,
                locality_id: localityId,
                shipping_type_price_value: shippingTypePriceValue,
                is_available_add_to_cart: !(date && time),
            },
            update: {
                "catalog/product-page/cart-form/gifts": ".gifts-wrapper",
                "catalog/product-page/cart-form/delivery-info":
                    ".delivery-info-wrapper",
            },
            complete: () => {
                const addToCartFormErrorElement =
                    document.getElementById("addToCartFormError");

                if (addToCartFormErrorElement) {
                    addToCartFormErrorElement.textContent = null;
                }

                document.getElementById("deliveryTime").value = time;
                document.getElementById("deliveryDate").value = date;
                document.getElementById("isExpressDelivery").value =
                    isExpressDelivery;
                document.getElementById("offerOrderDateTimeInput").value =
                    dateTimeText;

                disableProductPageFields(false);

                document.getElementById("select_date").close();
            },
        });
    });
};

const openCalendar = () => {
    EventListener.click("offerOrderDateTimeInput", (button) => {
        const partnerId = document.getElementById("partnerId").value;
        const localityId = document.getElementById("localityId").value;
        const offerId = document.getElementById("offerId").value;
        const shippingType = document.querySelector(
            ".change-shipping-type-radio:checked",
        ).value;

        oc.ajax("Settings::onAjax", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                partner_id: partnerId,
                locality_id: localityId,
                offer_id: offerId,
                shipping_type: shippingType,
            },
            update: {
                "catalog/product-page/cart-form/schedule": ".schedule-wrapper",
            },
            complete: () => {
                initCalendar();
                document.getElementById("select_date").showModal();
                button.disabled = false;
            },
        });
    });
};

const addCartPositionToCart = () => {
    EventListener.submit(
        "addCartPositionToCartForm",
        null,
        "addToCartFormError",
        (formData, button, formError, formMessage) => {
            disableProductPageFields(true);

            document
                .getElementById("addToCartFormSuccess")
                .classList.add("hidden");

            oc.ajax("Cart::onAddCartPosition", {
                loading: "#loader-line",
                data: {
                    _token: csrfToken,
                    item_id: formData.get("item_id"),
                    offer_id: formData.get("item_id"),
                    partner_id: formData.get("partner_id"),
                    locality_id: formData.get("locality_id"),
                    shipping_type: formData.get("shipping_type"),
                    delivery_date: formData.get("delivery_date"),
                    delivery_time: formData.get("delivery_time"),
                    gift_ids: formData.getAll("gift_ids"),
                    number_of_offers: formData.get("number_of_offers"),
                    is_express_delivery: formData.get("is_express_delivery"),
                    analytics: getAnalytics(),
                },
                update: {
                    "catalog/product-page/cart-form/cart-form":
                        ".cart-form-wrapper",
                    "main/header/cart": ".header-cart-wrapper",
                },
                complete: (result) => {
                    if (result.X_OCTOBER_REDIRECT) {
                        try {
                            if (isGa) {
                                const gaElement = document.getElementById(
                                    "add_product_to_cart_ec_addProduct",
                                );

                                if (gaElement) {
                                    const gaElementData = JSON.parse(
                                        gaElement.innerHTML,
                                    );
                                    ga("ec:addProduct", gaElementData);
                                }

                                ga("ec:setAction", "add");
                                ga(
                                    "send",
                                    "event",
                                    "UX",
                                    "click",
                                    "add to cart",
                                );
                            }
                            if (isDataLayer) {
                                const dataLayerElement =
                                    document.getElementById(
                                        "add_product_to_cart_eec_add",
                                    );

                                if (dataLayerElement) {
                                    const dataLayerElementData = JSON.parse(
                                        dataLayerElement.innerHTML,
                                    );
                                    dataLayer.push(dataLayerElementData);
                                }
                            }
                        } catch (e) {}
                    }
                    disableProductPageFields(false);

                    if (!result.status && result.message) {
                        formMessage.textContent = result.message;
                    } else {
                        document.getElementById(
                            "addCartPositionToCartButton",
                        ).disabled = true;
                    }

                    if (!result.message) {
                        document
                            .getElementById("addToCartFormSuccess")
                            .classList.remove("hidden");

                        setTimeout(() => {
                            document
                                .getElementById("addToCartFormSuccess")
                                .classList.add("hidden");
                        }, 3000);
                    }
                },
            });
        },
    );
};

const removeCartPositionFromCart = () => {
    EventListener.click("delete-cart-position-button", (button) => {
        const cartPositionId = button.getAttribute("data-cart-position-id");

        try {
            if (isDataLayer) {
                const dataLayerElement = document.getElementById(
                    "cart_recipient_form_details_ec_addProduct",
                );

                if (dataLayerElement) {
                    const dataLayerElementData = JSON.parse(
                        dataLayerElement.innerHTML,
                    );

                    const offerData = dataLayerElementData.find(
                        (item) => item.cart_position_id === cartPositionId,
                    );

                    dataLayer.push({
                        event: "eec.remove",
                        ecommerce: {
                            remove: {
                                actionField: {
                                    list: "Shopping cart",
                                },
                                products: [offerData],
                            },
                        },
                    });
                }
            }
        } catch (e) {}

        oc.ajax("Cart::onRemoveCartPosition", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                to_remove_cart_position_id: cartPositionId,
            },
            update: {
                "catalog/cart/cart-positions": ".cart-positions-wrapper",
                "gtm/cart-recipient-form": ".gtm-cart-positions-wrapper",
                "catalog/cart/cart-positions-description":
                    ".cart-positions-description-wrapper",
                "main/header/cart": ".header-cart-wrapper",
                "catalog/cart/cart-positions/order-form": ".order-form-wrapper",
                "catalog/cart/total-price": ".total-price-wrapper",
            },
            complete: (result) => {
                if (!result.X_OCTOBER_REDIRECT) {
                    focusOnActiveCartPosition();
                    window.scrollTo(0, 0);
                    button.disabled = false;
                }

                Validator.init();
            },
        });
    });
};

const cloneCartPositionToCart = () => {
    EventListener.click("clone-cart-position-button", (button) => {
        const cartPositionId = button.getAttribute("data-cart-position-id");

        oc.ajax("Cart::onCloneCartPosition", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                to_clone_cart_position_id: cartPositionId,
            },
            update: {
                "catalog/cart/cart-positions/order-form": ".order-form-wrapper",
                "catalog/cart/cart-positions": ".cart-positions-wrapper",
                "gtm/cart-recipient-form": ".gtm-cart-positions-wrapper",
                "catalog/cart/cart-positions-description":
                    ".cart-positions-description-wrapper",
                "main/header/cart": ".header-cart-wrapper",
            },
            complete: (result) => {
                if (!result.status) {
                    focusOnActiveCartPosition();
                    window.scrollTo(0, 0);
                }

                button.disabled = false;

                Validator.init();
            },
        });
    });
};

const addCartPositionGiftToCart = () => {
    EventListener.click("add-cart-position-gift-button", (button) => {
        const giftOfferId = button.getAttribute("data-gift-offer-id");
        const activeCartPositionId = document.getElementById(
            "activeCartPositionId",
        ).value;
        const giftCategoryId = document.getElementById("giftCategoryId").value;

        oc.ajax("Cart::onAddCartPositionGift", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                gift_offer_id: giftOfferId,
                cart_position_id: activeCartPositionId,
                active_cart_position_id: activeCartPositionId,
                category_id: giftCategoryId,
            },
            update: {
                "catalog/cart/cart-positions": ".cart-positions-wrapper",
                "gtm/cart-recipient-form": ".gtm-cart-positions-wrapper",
                "catalog/cart/cart-positions-description":
                    ".cart-positions-description-wrapper",
                "catalog/cart/cart-position-form/positions":
                    ".active-cart-positions-wrapper",
                "catalog/cart/total-price": ".total-price-wrapper",
                "catalog/cart/cart-position-form/gift-products":
                    ".gift-products-wrapper",
            },
            complete: () => {
                focusOnActiveCartPosition();
                button.disabled = false;
            },
        });
    });
};

const reduceOrIncreaseCartPositionGiftToCart = () => {
    const handle = (handler, button) => {
        const cartPositionGiftId = button.getAttribute(
            "data-cart-position-gift-id",
        );
        const activeCartPositionId = document.getElementById(
            "activeCartPositionId",
        ).value;

        oc.ajax(`Cart::${handler}`, {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                cart_position_gift_id: cartPositionGiftId,
                cart_position_id: activeCartPositionId,
                active_cart_position_id: activeCartPositionId,
            },
            update: {
                "catalog/cart/cart-positions": ".cart-positions-wrapper",
                "gtm/cart-recipient-form": ".gtm-cart-positions-wrapper",
                "catalog/cart/cart-positions-description":
                    ".cart-positions-description-wrapper",
                "catalog/cart/total-price": ".total-price-wrapper",
                "catalog/cart/cart-position-form/positions":
                    ".active-cart-positions-wrapper",
            },
            complete: () => {
                focusOnActiveCartPosition();
                button.disabled = false;
            },
        });
    };

    EventListener.click("reduce-cart-position-gift-button", (button) => {
        handle("onReduceCartPositionGiftQuantity", button);
    });

    EventListener.click("increase-cart-position-gift-button", (button) => {
        handle("onIncreaseCartPositionGiftQuantity", button);
    });
};

const changeCartPositionForm = () => {
    EventListener.click("change-cart-position-form-button", (button) => {
        document
            .querySelectorAll(".change-cart-position-form-button")
            .forEach((element) => {
                element.disabled = true;
            });

        const cartPositionId = button.getAttribute("data-cart-position-id");

        oc.ajax("Settings::onAjax", {
            loading: "#loader-line",
            data: {
                _token: csrfToken,
                cart_position_id: cartPositionId,
                active_cart_position_id: cartPositionId,
            },
            update: {
                "catalog/cart/cart-positions/order-form": ".order-form-wrapper",
                "catalog/cart/cart-positions": ".cart-positions-wrapper",
                "gtm/cart-recipient-form": ".gtm-cart-positions-wrapper",
                "catalog/cart/cart-positions-description":
                    ".cart-positions-description-wrapper",
            },
            complete: () => {
                focusOnActiveCartPosition();

                document
                    .querySelectorAll(".change-cart-position-form-button")
                    .forEach((element) => {
                        element.disabled = false;
                    });

                document.querySelector(
                    ".create-order-form-wrapper",
                ).textContent = null;

                Validator.init();
            },
        });
    });
};

const saveCartPositionRecipientData = () => {
    EventListener.submit(
        "saveCartPositionRecipientForm",
        "saveCartPositionRecipientFormError",
        null,
        (formData, button, formError) => {
            oc.ajax("Cart::onSaveCartPositionRecipientData", {
                data: {
                    _token: csrfToken,
                    cart_position_id: formData.get("active_cart_position_id"),
                    first_name: formData.get("first_name"),
                    last_name: formData.get("last_name"),
                    phone: formData.get("phone"),
                    zip_code: formData.get("zip_code"),
                    address: formData.get("address"),
                    comment: formData.get("comment"),
                    is_anonymously: formData.get("is_anonymously"),
                    congratulatory_message: formData.get(
                        "congratulatory_message",
                    ),
                    signature: formData.get("signature"),
                },
                loading: "#loader-line",
                update: {
                    "catalog/cart/cart-positions": ".cart-positions-wrapper",
                    "gtm/cart-recipient-form": ".gtm-cart-positions-wrapper",
                    "catalog/cart/cart-positions/order-form":
                        ".order-form-wrapper",
                    "catalog/cart/cart-positions-description":
                        ".cart-positions-description-wrapper",
                },
                complete: (result) => {
                    if (!result.status && result.message) {
                        formError.textContent = result.message;

                        setTimeout(() => {
                            formError.textContent = null;
                        }, 15000);
                    } else {
                        Validator.init();
                    }

                    focusOnActiveCartPosition();

                    document
                        .querySelector(".cart-positions-description-wrapper")
                        .scrollIntoView({
                            block: "start",
                        });

                    button.disabled = false;
                },
            });
        },
    );
};

const changePossibleAddress = () => {
    EventListener.change("possibleAddressId", (select) => {
        disableProductPageFields(true);

        const addressElement = document.getElementById("address");

        if (!addressElement) {
            return;
        }

        addressElement.value = select.value.trim();

        select.disabled = false;

        const event = new Event("input", {
            bubbles: true,
            cancelable: true,
        });

        addressElement.dispatchEvent(event);
    });
};

const createOrder = () => {
    const saveCartPositionRecipientDataRequest = (formData) => {
        return new Promise((resolve) => {
            return oc.ajax("Cart::onSaveCartPositionRecipientData", {
                data: {
                    _token: csrfToken,
                    cart_position_id: formData.get("active_cart_position_id"),
                    cart_position_recipient_id: formData.get(
                        "active_cart_position_recipient_id",
                    ),
                    first_name: formData.get("first_name"),
                    last_name: formData.get("last_name"),
                    phone: formData.get("phone"),
                    zip_code: formData.get("zip_code"),
                    address: formData.get("address"),
                    comment: formData.get("comment"),
                    is_anonymously: formData.get("is_anonymously"),
                    congratulatory_message: formData.get(
                        "congratulatory_message",
                    ),
                    signature: formData.get("signature"),
                },
                loading: "#loader-line",
                complete: (result) => resolve(result),
            });
        });
    };

    const createOrderRequest = (formData) => {
        return new Promise((resolve) => {
            return oc.ajax("Cart::onCreateOrder", {
                data: {
                    _token: csrfToken,
                    is_remind: formData.get("is_remind"),
                    analytics: getAnalytics(),
                },
                loading: "#loader-line",
                complete: (result) => resolve(result),
            });
        });
    };

    const singleOrder = async (formData, button, formError) => {
        const saveCartPositionRecipientDataResponse =
            await saveCartPositionRecipientDataRequest(formData);

        if (saveCartPositionRecipientDataResponse.status === false) {
            formError.textContent =
                saveCartPositionRecipientDataResponse.message;
        } else {
            const createOrderResponse = await createOrderRequest(formData);

            if (createOrderResponse.status === false) {
                formError.textContent = createOrderResponse.message;
            }

            if (!createOrderResponse.X_OCTOBER_REDIRECT) {
                button.disabled = false;
            }
        }
    };

    const multipleOrder = async (formData, button, formError) => {
        const createOrderResponse = await createOrderRequest(formData);

        if (createOrderResponse && !createOrderResponse.status) {
            formError.textContent = createOrderResponse.message;
        }

        if (!createOrderResponse.X_OCTOBER_REDIRECT) {
            button.disabled = false;
        }
    };

    EventListener.submit(
        "createOrderForm",
        "createOrderError",
        null,
        async (formData, button, formError) => {
            const isMultipleOrder =
                document.querySelectorAll(".bouquet-item ").length > 1;

            if (isMultipleOrder) {
                await multipleOrder(formData, button, formError);
            } else {
                await singleOrder(formData, button, formError);
            }

            setTimeout(() => {
                formError.textContent = null;
            }, 15000);
        },
    );

    const createOrderByKey = () => {
        const form = document.getElementById("createOrderForm");

        if (!form) {
            return;
        }

        form.addEventListener("keypress", function (event) {
            if (event.key === "Enter") {
                const target = event.target;
                if (target.tagName === "INPUT" && target.type !== "textarea") {
                    event.preventDefault();
                    const orderFormButton =
                        document.getElementById("orderFormButton");

                    if (orderFormButton) {
                        orderFormButton.click();
                    }
                }
            }
        });
    };

    createOrderByKey();
};

const applyPromoCode = () => {
    EventListener.click("applyPromoCodeButton", (button) => {
        const promoCode = document
            .getElementById("applyPromoCode")
            .value.trim()
            .toLowerCase();

        document.getElementById("promoCodeError").textContent = null;

        if (promoCode.length < 3) {
            button.disabled = false;

            return;
        }

        oc.ajax("Cart::onApplyPromoCode", {
            data: {
                _token: csrfToken,
                promo_code: promoCode,
            },
            update: {
                "catalog/cart/promo-code-form": ".promo-code-wrapper",
                "catalog/cart/cart-positions": ".cart-positions-wrapper",
                "gtm/cart-recipient-form": ".gtm-cart-positions-wrapper",
                "catalog/cart/total-price": ".total-price-wrapper",
                "catalog/cart/cart-position-form/positions":
                    ".active-cart-positions-wrapper",
            },
            complete: (result) => {
                if (!result.status && result.message) {
                    const formError = document.getElementById("promoCodeError");

                    if (formError) {
                        formError.textContent = result.message;

                        setTimeout(() => {
                            formError.textContent = null;
                        }, 15000);
                    }
                }

                button.disabled = false;
            },
        });
    });
};

const resetPromoCode = () => {
    EventListener.click("resetPromoCode", (button) => {
        document.getElementById("promoCodeError").textContent = null;

        oc.ajax("Cart::onResetPromoCode", {
            data: { _token: csrfToken },
            update: {
                "catalog/cart/promo-code-form": ".promo-code-wrapper",
                "catalog/cart/cart-positions": ".cart-positions-wrapper",
                "gtm/cart-recipient-form": ".gtm-cart-positions-wrapper",
                "catalog/cart/total-price": ".total-price-wrapper",
                "catalog/cart/cart-position-form/positions":
                    ".active-cart-positions-wrapper",
            },
            complete: (result) => {
                if (!result.status && result.message) {
                    const formError = (document.getElementById(
                        "promoCodeError",
                    ).textContent = result.message);

                    setTimeout(() => {
                        formError.textContent = null;
                    }, 15000);
                }
            },
        });
    });
};

const inputAddress = () => {
    EventListener.input("address", (addressElement) => {
        const addressListElement = document.getElementById("possibleAddressId");

        if (
            !addressElement ||
            !addressListElement ||
            addressListElement.value === addressElement.value
        ) {
            return;
        }

        addressListElement.value = "";
    });
};

const getAnalytics = () => {
    const browser = Bowser.getParser(window.navigator.userAgent);

    return {
        os: browser.getOSName(),
        device: browser.getPlatformType(),
    };
};

const fillInCartDetails = () => {
    let debounceTimer;
    let values = {};

    EventListener.input("fill-in-cart-details", (element) => {
        if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
            Validator.getBouncer().validate(element);

            const name = element.name.trim();

            if (!element.classList.contains("error")) {
                clearTimeout(debounceTimer);

                const parentElement = element.closest(
                    "[data-fill-in-cart-details]",
                );

                const form = parentElement.getAttribute(
                    "data-fill-in-cart-details",
                );

                let value = element.value.trim();

                if (element.type === "checkbox") {
                    value = element.checked;
                }

                const activeCartPositionIdElement = document.getElementById(
                    "activeCartPositionId",
                );

                let activeCartPositionId = null;

                if (activeCartPositionIdElement) {
                    activeCartPositionId = activeCartPositionIdElement.value;
                }

                values[name] = value;

                debounceTimer = setTimeout(() => {
                    if (Object.keys(values).length === 0) {
                        return;
                    }

                    oc.ajax("Cart::onFillInCartDetails", {
                        data: {
                            _token: csrfToken,
                            values: values,
                            form: form,
                            active_cart_position_id: activeCartPositionId,
                        },
                    });

                    values = {};
                }, 3000);
            } else {
                delete values[name];
            }
        }
    });
};

const clickTextOverlayButton = () => {
    EventListener.click("text-overlay-button", (button) => {
        const openClass = "show";
        const block = document.querySelector(".text-overlay");

        if (block.classList.contains(openClass)) {
            block.classList.remove(openClass);
        } else {
            block.classList.add(openClass);
        }

        button.disabled = false;
    });
};

fillInCartDetails();
addCartPositionToCart();
removeCartPositionFromCart();
cloneCartPositionToCart();
addCartPositionGiftToCart();
reduceOrIncreaseCartPositionGiftToCart();
search();
changeLocality();
changeShippingType();
changeOfferOrderDateByTab();
changeOfferOrderTime();
openCalendar();
changeCartPositionForm();
saveCartPositionRecipientData();
changePossibleAddress();
createOrder();
applyPromoCode();
resetPromoCode();
inputAddress();
clickTextOverlayButton();
